import React from "react";

import { Constants as GridConstants } from "Components/AppGrid/shipeezi-new-grid";
import { useTranslation } from "react-i18next";
import { GoContainer } from "react-icons/go";

import Button, { Color } from "../../../../Form/Button";
import { DefaultTooltip } from "../../../Tooltip";
import useStyles from "../../styles";

interface Props {
  show: boolean;
  disabled?: boolean;
  loading?: boolean;
  onClick?: () => void;
}

const AddContainerButton = (props: Props) => {
  const { show, loading, disabled, onClick } = props;

  const classes = useStyles();
  const { t: translate } = useTranslation();

  if (!show) return null;

  return (
    <DefaultTooltip title={translate("addInAContainer")}>
      <div>
        <Button
          loading={loading}
          customColor={Color.SECONDARY_OUTLINED}
          onClick={onClick}
          disabled={disabled}
        >
          <div className={classes.printLabelButton}>
            <GoContainer size={GridConstants.defaultRowActionSize} />
            <span className={classes.buttonText}>{translate("addInAContainer")}</span>
          </div>
        </Button>
      </div>
    </DefaultTooltip>
  );
};

export default AddContainerButton;
